import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { forceDownload } from '@fc-core/files-uploads/components/file-card/file-card.component';
import { ButtonComponent } from '@fc-shared/ui/buttons/button.component';
import { IconComponent } from '@fc-shared/ui/icon/icon.component';

@Component({
  selector: 'fc-media-view-placeholder',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex h-full w-full items-center justify-center p-16' },
  template: `
    <div class="flex max-w-320 flex-col items-center gap-16 text-center">
      <span
        class="flex size-80 items-center justify-center rounded-full bg-primary-100"
      >
        <fc-icon icon="icon-file" [size]="40" color="primary600" />
      </span>
      <div class="flex min-w-0 flex-col gap-4">
        <span class="truncate text-base font-medium text-white">
          {{ fileName() }}
        </span>
        <span class="text-sm text-secondary-300">
          {{
            isPreviewPending()
              ? 'Preview is being prepared'
              : 'No preview available'
          }}
        </span>
      </div>
      @if (downloadUrl(); as url) {
        <fc-button icon="icon-download" (click)="downloadFile(url)">
          Download
        </fc-button>
      }
    </div>
  `,
  imports: [ButtonComponent, IconComponent],
})
export class MediaViewPlaceholderComponent {
  readonly fileName = input.required<string>();
  readonly downloadUrl = input<string | null>(null);
  readonly isPreviewPending = input(false);

  protected downloadFile(url: string): void {
    void forceDownload(url, this.fileName());
  }
}
